import PageHead from "@/components/header/PageHead";
import ChangeControlComponent from '@/components/change/ChangeControlComponent';
import { getPrefix } from "@/utils/common";
export default {
  name: "ChangeControl",
  components: {
    PageHead,
    ChangeControlComponent
  },
  data() {
    return {
      nodeId: ''
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.nodeId = getPrefix() + this.$route.params.provider;
      this.$store.dispatch('getNodePublicInfo', {
        nodeId: this.nodeId
      });
    }
  },
  computed: {
    docsUrlPrefix() {
      return `https://docs.stfil.io/${this.$i18n.locale === "zh" ? 'v/cn/' : ''}`;
    }
  }
};